import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditLogo = () => {
    const [editlogo, setLogo] = useState([]);
    const { id } = useParams();

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/logo/${id}`)
            .then((res) => res.json())
            .then((info) => setLogo(info));
    }, []);

    const handleLogo = (event) => {
        event.preventDefault();
        const logo = event.target.logo.value;

        const logoSection = { logo };

        const url = `https://aprilone-178ea8362c0b.herokuapp.com/logo/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(logoSection),
        })
            .then((res) => res.json())
            .then((result) => {
                alert('Logo is Updated');
            });
    };

    return (
        <>
            <HeaderBottom></HeaderBottom>

            <section id="services" className="services-area  d-flex justify-content-center align-items-center">
                <div className="container">
                    <div className="row justify-content-center vh-100">
                        <div className="col-lg-8 col-md-12 text-center ">
                            <h2 className="mb-5">Update Your Logo</h2>

                            <form className="contact-form" onSubmit={handleLogo}>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 mb-3">
                                        <div className="form-group">
                                            <input type="text" className="form-control  text-center" name="logo" defaultValue={editlogo.logo} placeholder="Submit Logo" required />
                                        </div>
                                    </div>

                                    <div className="slider-btn">
                                        <button className="button-professional" data-animation="fadeInRight" data-delay=".8s">Update Your Logo</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EditLogo;
